import TableRequest from '@/classes/TableRequest'
import { Filter } from '@/classes/filters'

export default {
  data () {
    return {
      isLoading: false,
      fetchItemsOnLoad: true,

      cancelToken: null,

      items: [],
      fields: [],
      sort: {
        desc: true
      },
      pagination: {
        pageNumber: 1,
        pageSize: 25,
        totalCount: 0
      }
    }
  },

  computed: {
    /**
     * Default empty filter array
     */
    filters: {
      get () {
        return []
      },
      set () { }
    },

    /**
     * Get custom sort object.
     *
     * @return {Object}
     */
    customSort () {
      const sort = {
        by: this.sort.by,
        desc: this.sort.desc
      }

      // Use custom sort by
      if (this.fields.hasOwnProperty(this.sort.by) && this.fields[this.sort.by].hasOwnProperty('sortBy')) {
        sort.by = this.fields[this.sort.by].sortBy
      }

      return sort
    }
  },

  /**
   * Load state, load items and after that set watchers.
   */
  created () {
    if (this.$route.params.filters) {
      this.filters = this.$route.params.filters.map(item => new Filter(item.key, item.property, item.value))
    } else {
      this.loadState()
    }

    if (this.fetchItemsOnLoad) {
      this.loadItems()
    }

    this.$nextTick(() => {
      this.$watch(() => this.sort, this.reloadItems, { deep: true })
      this.$watch(() => this.pagination.pageNumber, this.loadItems)
      this.$watch(() => this.pagination.pageSize, this.reloadItems)
      this.$watch(() => this.filters.map(filter => filter.value), this.reloadItems)
    })
  },

  methods: {
    /**
    * Set selected page
    */
    onPageNumberSelect (selectedPageNumber) {
      this.pagination.pageNumber = selectedPageNumber
    },

    /**
     * Reset page and reload items.
     */
    reloadItems () {
      // Pagination
      if (this.pagination.pageNumber === 1) {
        this.loadItems()
      } else {
        this.pagination.pageNumber = 1
      }
    },

    /**
     * Save the state in the store.
     */
    saveState () {
      this.$store.commit('overviewSettings', {
        name: this.$options.name,
        settings: {
          sort: this.sort,
          filters: this.filters,
          pagination: this.pagination
        }
      })
    },

    /**
     * Load the state from the store (if any).
     */
    loadState () {
      const settings = this.$store.getters.overviewSettings(this.$options.name)

      if (!settings) {
        return
      }

      this.sort = settings.sort
      this.filters = settings.filters
      this.pagination = settings.pagination
    },

    /**
     * Load items.
     */
    loadItems () {
      this.isLoading = true

      this.saveState()

      const tableRequest = new TableRequest(
        this.pagination.pageNumber,
        this.pagination.pageSize,
        this.customSort,
        this.filters
      )

      if (this.cancelToken) {
        this.cancelToken.cancel()
      }

      this.getItems(tableRequest).then(({ promise, cancelToken }) => {
        this.cancelToken = cancelToken

        promise.then((result) => {
          this.items = result.data
          this.pagination.totalCount = parseInt(result.totalCount)
        }).catch(() => {
          this.items = []
          this.pagination.totalCount = 0
        }).finally(() => {
          this.isLoading = false
        })
      })
    }
  }
}
